import _styled from "@emotion/styled/base";
import generateGridStyles from './generateGridStyles';
const GridContainer = _styled('div', {
  target: "eds0yfe0"
})("display:", _ref => {
  let {
    isInline
  } = _ref;
  return isInline ? 'inline-grid' : 'grid';
}, ";", _ref2 => {
  let {
    gridTemplateColumns,
    gridTemplateRows,
    gridTemplateAreas,
    gridTemplate,
    columnGap,
    rowGap,
    gap,
    justifyItems,
    alignItems,
    placeItems,
    justifyContent,
    alignContent,
    gridAutoColumns,
    gridAutoRows,
    gridAutoFlow,
    gridRow,
    grid,
    gridColumnStart,
    gridColumnEnd,
    gridRowStart,
    gridRowEnd,
    gridColumn,
    gridArea,
    justifySelf,
    alignSelf,
    placeSelf
  } = _ref2;
  return generateGridStyles({
    gridTemplateColumns,
    gridTemplateRows,
    gridTemplateAreas,
    gridTemplate,
    columnGap,
    rowGap,
    gap,
    justifyItems,
    alignItems,
    placeItems,
    justifyContent,
    alignContent,
    gridAutoColumns,
    gridAutoRows,
    gridAutoFlow,
    gridRow,
    grid,
    gridColumnStart,
    gridColumnEnd,
    gridRowStart,
    gridRowEnd,
    gridColumn,
    gridArea,
    justifySelf,
    alignSelf,
    placeSelf
  });
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9sYXlvdXQvR3JpZENvbnRhaW5lci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSzBEIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9sYXlvdXQvR3JpZENvbnRhaW5lci50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgZ2VuZXJhdGVHcmlkU3R5bGVzIGZyb20gJy4vZ2VuZXJhdGVHcmlkU3R5bGVzJztcbmltcG9ydCB7IENzc0dyaWRDb250YWluZXJSdWxlcyB9IGZyb20gJy4vdHlwZXMnO1xuXG4vLyBDb250YWluZXIgdXRpbGl6aW5nIENTUyBncmlkXG5jb25zdCBHcmlkQ29udGFpbmVyID0gc3R5bGVkKCdkaXYnKTxDc3NHcmlkQ29udGFpbmVyUnVsZXM+YFxuICBkaXNwbGF5OiAkeyh7IGlzSW5saW5lIH0pID0+IGlzSW5saW5lID8gJ2lubGluZS1ncmlkJyA6ICdncmlkJ307XG5cbiAgJHsoe1xuICAgIGdyaWRUZW1wbGF0ZUNvbHVtbnMsXG4gICAgZ3JpZFRlbXBsYXRlUm93cyxcbiAgICBncmlkVGVtcGxhdGVBcmVhcyxcbiAgICBncmlkVGVtcGxhdGUsXG4gICAgY29sdW1uR2FwLFxuICAgIHJvd0dhcCxcbiAgICBnYXAsXG4gICAganVzdGlmeUl0ZW1zLFxuICAgIGFsaWduSXRlbXMsXG4gICAgcGxhY2VJdGVtcyxcbiAgICBqdXN0aWZ5Q29udGVudCxcbiAgICBhbGlnbkNvbnRlbnQsXG4gICAgZ3JpZEF1dG9Db2x1bW5zLFxuICAgIGdyaWRBdXRvUm93cyxcbiAgICBncmlkQXV0b0Zsb3csXG4gICAgZ3JpZFJvdyxcbiAgICBncmlkLFxuICAgIGdyaWRDb2x1bW5TdGFydCxcbiAgICBncmlkQ29sdW1uRW5kLFxuICAgIGdyaWRSb3dTdGFydCxcbiAgICBncmlkUm93RW5kLFxuICAgIGdyaWRDb2x1bW4sXG4gICAgZ3JpZEFyZWEsXG4gICAganVzdGlmeVNlbGYsXG4gICAgYWxpZ25TZWxmLFxuICAgIHBsYWNlU2VsZixcbiAgfSkgPT4gZ2VuZXJhdGVHcmlkU3R5bGVzKHtcbiAgICBncmlkVGVtcGxhdGVDb2x1bW5zLFxuICAgIGdyaWRUZW1wbGF0ZVJvd3MsXG4gICAgZ3JpZFRlbXBsYXRlQXJlYXMsXG4gICAgZ3JpZFRlbXBsYXRlLFxuICAgIGNvbHVtbkdhcCxcbiAgICByb3dHYXAsXG4gICAgZ2FwLFxuICAgIGp1c3RpZnlJdGVtcyxcbiAgICBhbGlnbkl0ZW1zLFxuICAgIHBsYWNlSXRlbXMsXG4gICAganVzdGlmeUNvbnRlbnQsXG4gICAgYWxpZ25Db250ZW50LFxuICAgIGdyaWRBdXRvQ29sdW1ucyxcbiAgICBncmlkQXV0b1Jvd3MsXG4gICAgZ3JpZEF1dG9GbG93LFxuICAgIGdyaWRSb3csXG4gICAgZ3JpZCxcbiAgICBncmlkQ29sdW1uU3RhcnQsXG4gICAgZ3JpZENvbHVtbkVuZCxcbiAgICBncmlkUm93U3RhcnQsXG4gICAgZ3JpZFJvd0VuZCxcbiAgICBncmlkQ29sdW1uLFxuICAgIGdyaWRBcmVhLFxuICAgIGp1c3RpZnlTZWxmLFxuICAgIGFsaWduU2VsZixcbiAgICBwbGFjZVNlbGYsXG4gIH0pfTtcbmA7XG5cbmV4cG9ydCBkZWZhdWx0IEdyaWRDb250YWluZXI7XG4iXX0= */"));
export default GridContainer;
//# sourceMappingURL=GridContainer.js.map